import { formatDuration, formatNumber, truncatePath } from "./formatters";

const TopPagesTable = ({ topPages = [] }) => (
  <div className="bg-surface-container-low rounded-2xl p-6 border border-surface-container-high">
    <h3 className="font-headline text-base font-bold mb-4">Top Pages</h3>
    {topPages.length === 0 ? (
      <p className="text-sm text-on-surface-variant">No pageviews recorded in this period.</p>
    ) : (
      <div className="overflow-auto max-h-72 pr-2">
        <table className="w-full text-sm min-w-[480px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-on-surface-variant sticky top-0 z-10 bg-surface-container-low">
              <th className="pb-3 font-semibold">Page</th>
              <th className="pb-3 font-semibold text-right">Pageviews</th>
              <th className="pb-3 font-semibold text-right">Avg engagement</th>
            </tr>
          </thead>
          <tbody>
            {topPages.map((row) => (
              <tr
                key={`${row.page_path}-${row.page_title}`}
                className="border-t border-surface-container-high"
              >
                <td className="py-3 pr-4">
                  <p className="text-on-surface" title={row.page_title}>
                    {row.page_title || "(no title)"}
                  </p>
                  <p className="text-xs text-on-surface-variant" title={row.page_path}>
                    {truncatePath(row.page_path)}
                  </p>
                </td>
                <td className="py-3 text-right text-on-surface align-top">
                  {formatNumber(row.pageviews)}
                </td>
                <td className="py-3 text-right text-on-surface-variant align-top">
                  {formatDuration(row.avg_engagement_seconds)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default TopPagesTable;
